import { AutorenewRetailPriceComponentModule } from '@b2b/autorenew/components/autorenew-retail-price';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { LooseAutocomplete, TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import { MembershipLevelOffering } from '@b2b/types/membership';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IPromise, IQService, ISCEService, IScope, ITimeoutService } from 'angular';
import invariant from 'tiny-invariant';

interface MembershipEligibility {
  membershipOptions: {
    eligibleMembershipLevels: {
      type: LooseAutocomplete<'new_memberships'>;
      targetLevels: TODO[];
    }[];
  };
}

RetailMembershipsController.$inject = [
  '$scope',
  '$q',
  '$state',
  '$filter',
  '$timeout',
  '$uibModal',
  '$sce',
  'ApiService',
  'PermissionsService',
  'FeatureToggleService',
  'HelpersService',
  'UserPreferencesService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'NoticeFactory',
  'MembershipService',
  'ThemesHelperService',
  'CartService',
  'MEMBERSHIP_ENUMS',
];

function RetailMembershipsController(
  $scope: IScope & { retailMemberships: TODO },
  $q: IQService,
  $state: StateService,
  $filter: IFilterService,
  $timeout: ITimeoutService,
  $uibModal: UIBModalService,
  $sce: ISCEService,
  ApiService: ApiService,
  PermissionsService: PermissionsService,
  FeatureToggleService: TODO,
  HelpersService: TODO,
  UserPreferencesService: TODO,
  GridStateFactory: TODO,
  GridDefinitionFactory: TODO,
  NoticeFactory: NoticeFactory,
  MembershipService: TODO,
  ThemesHelperService: ThemesHelperService,
  CartService: CartService,
  MEMBERSHIP_ENUMS: TODO
) {
  const ctrl = {
    model: [] as TODO[],

    selected: false as { level: TODO } | false,

    searchQuery: '',
    isLoaded: false,
    showFullDetails: false,

    isAuxiliaryMembershipEnabled: false,
    viewId: '',
    gridName: $state.current.name + '.grid0',

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    notice: new NoticeFactory(),
    strip: HelpersService.strip,
    company: ThemesHelperService.getCompany(),

    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),

    optionsOverride: {
      useAccessibleGrid: true,
      enableSorting: false,
      rowClasses: "{ 'ui-grid-row-header-cell': col.isRowHeader, 'retail-memberships-row': true  }",
      showEmpty: true,
      multiSelect: false,
      rowHeight: 40,
      data: 'retailMemberships.model',
      enableGridMenu: false,
      enablePagination: false,
      showGridFooter: false,
      appScopeProvider: {
        onDataGridPaginate: (newPageNumber, newPageSize) => {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize);
        },
        onDataGridSortChange: (grid, columns, page) => {
          ctrl.onDataGridSortChange(grid, columns);
        },
        onDataGridSelectionChange: (row, e) => {
          ctrl.onDataGridSelectionChange(row, e);
        },
        addToCart: (item) => {
          ctrl.addToCart(item);
        },
        viewDetail: (item) => {
          ctrl.viewDetail(item);
        },
      },
      columnDefs: [
        {
          field: 'type',
          displayName: '',
          enableHiding: false,
          enableSorting: false,
          cellTemplate:
            '<div><div data-ng-if="row.groupHeader" class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div></div>',
          visible: false,
        },
        {
          field: 'membershipLevelName',
          displayName: 'Membership',
          sort: {
            direction: 'desc',
          },
          headerTooltip: true,
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'offerings',
          displayName: 'Offerings',
          headerTooltip: true,
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'cardHolders',
          displayName: 'Cardholders',
          headerTooltip: true,
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'duration',
          displayName: 'Duration',
          headerTooltip: true,
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'priceRange',
          displayName: 'Price',
          headerTooltip: true,
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
      ],
    },

    filterOptions: [
      {
        type: 'all',
        name: 'All',
      },
      {
        type: 'regular',
        name: 'Regular',
      },
      {
        type: 'auxiliary',
        name: 'Auxiliary',
      },
    ],

    selectedFilter: false as { type: string; name: string } | false,

    currentGroup: false as { id: number } | false,
    groupName: '',
    isRegular: true,

    membershipId: null as number | null,
    orderContactId: null,
    lifecycleType: null,

    currentMembership: false as
      | {
          categoryId: TODO;
          membershipCategory: TODO;
          offeringName: TODO;
          offeringId: TODO;
          offering: TODO;
          pricePointId: TODO;
          pricepoint: TODO;
        }
      | false,

    detailsModal: {},

    eligibility: false as MembershipEligibility | false,

    lifecycleActions: [],

    selectedLifecycle: false,

    showLifeCycleActions: false,

    init: () => {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Memberships',
      });

      if (PermissionsService.check('MEMBERSHIP_SALES')) {
        ctrl.optionsOverride.columnDefs.push({
          field: 'action',
          displayName: '',
          headerTooltip: true,
          width: 40,
          // cellClass: 'retail-memberships-grid-cell',
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.addToCart(row.entity);
          },
          cellTemplate:
            '<div class="ui-grid-cell-text" ng-class="col.colIndex()">' +
            '<a data-ng-if="row.entity.hasSinglePricepoint" data-permit="MEMBERSHIP_SALES" title="Add to cart" role="button" class="retail-memberships-link retail-memberships-cart" data-ng-click="grid.appScope.addToCart(row.entity)">' +
            '<span class="fa fa-shopping-cart" role="presentation"></span><span class="sr-only">Add {{ row.entity.offerings }} to cart</span>' +
            '</a>' +
            '<a data-ng-if="!row.entity.hasSinglePricepoint" title="View offerings" role="button" class="retail-memberships-link retail-memberships-detail" data-ng-click="grid.appScope.viewDetail(row)">' +
            '<span class="fa fa-caret-right" role="presentation"></span><span class="sr-only">View offerings for {{ row.entity.offerings }}</span>' +
            '</a>' +
            '</div>',
          visible: true,
          enableHiding: false,
          suppressSizeToFit: true,
          enableSorting: false,
        } as any);
      }

      ctrl.viewId = $state.current.name ?? '';

      ctrl.selectedFilter = ctrl.filterOptions[0];

      if ($state.params.membershipId) {
        ctrl.membershipId = $state.params.membershipId;
      }
      if ($state.params.orderContactId) {
        ctrl.orderContactId = $state.params.orderContactId;
      }
      if ($state.params.lifecycleType) {
        ctrl.lifecycleType = $state.params.lifecycleType;
        ctrl.showLifeCycleActions = true;
      }

      if (ctrl.company && ctrl.company.auxiliaryMembership) {
        ctrl.isAuxiliaryMembershipEnabled = ctrl.company.auxiliaryMembership;
        if (ctrl.isAuxiliaryMembershipEnabled) {
          ctrl.optionsOverride.columnDefs.splice(2, 0, {
            field: 'auxGroup',
            displayName: 'Aux Group',
            headerTooltip: true,
            visible: true,
            enableHiding: false,
            enableSorting: false,
          });
        }
      }

      ctrl.gridDefinition.init(ctrl.gridName, ctrl.optionsOverride, ctrl.viewId, false);

      // Watch the isRegular var for changes and reload if new and old are the same, which
      // indicates it this is the initial state, so automatically load
      $scope.$watch('retailMemberships.isRegular', (n, o) => {
        if (n !== o) {
          ctrl.getLevels();
          if (ctrl.isRegular) {
            $scope.$broadcast('RetailMembershipsSidebar::Reset');
          }
        }
      });

      if (ctrl.showLifeCycleActions) {
        ctrl.getActions();
        // $scope.$watch('retailMemberships.selectedLifecycle', ctrl.getMembershipLevels);
      }

      $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.membershipId ? ctrl.getMembership : ctrl.getMembershipLevels);
    },

    getActions: () => {
      if (!ctrl.membershipId) {
        ctrl.selectedLifecycle = MEMBERSHIP_ENUMS.newmembership;
      } else {
        ctrl.selectedLifecycle =
          ctrl.lifecycleType && MEMBERSHIP_ENUMS.hasOwnProperty(ctrl.lifecycleType)
            ? MEMBERSHIP_ENUMS[ctrl.lifecycleType]
            : MEMBERSHIP_ENUMS.renew;
      }
    },

    showDetails: () => {
      let name;
      let auxGroup;
      let thumbnail;
      let description;
      let benefits;

      if (ctrl.selected && ctrl.selected.level) {
        name = ctrl.selected.level.name;
        description = ctrl.selected.level.description;
        thumbnail = ctrl.getScreen(ctrl.selected.level);
        benefits = ctrl.selected.level.benefits;
        if (ctrl.selected.level.auxiliary) {
          auxGroup = ctrl.selected.level.membershipLevelCollection[0].name;
        }
      }

      const detailsModal: UIBModal<TODO> = $uibModal.open({
        size: 'lg',
        controller: 'MembershipModalController',
        templateUrl: 'common/views/modals/membership/membership.tpl.html',
        resolve: {
          modalDetails: () => {
            return {
              name: name,
              group: auxGroup,
              desc: description,
              benefits: benefits,
              thumbnail: thumbnail,
            };
          },
        },
      });

      detailsModal.result
        .then(() => {
          // $scope.$emit('Cart::Close');
          // ctrl.cartService.cancelCart().then(ctrl.success.cancel, ctrl.error.cancel);
        })
        .catch(() => {
          // Do nothing
        });
    },

    getMembershipLevels: () => {
      if (ctrl.membershipId) {
        ctrl.getMembershipEligibility();
      } else {
        ctrl.getLevels();
      }
    },

    getMembership: () => {
      invariant(ctrl.membershipId != null);
      ApiService.membership.detail(ctrl.membershipId).then(ctrl.success.getMembership).catch(ctrl.error.getMembership);
    },

    changeFilterOption: (e, data) => {
      ctrl.search();
    },

    search: () => {
      let levels;
      const currentMembership = ctrl.currentMembership === false ? undefined : ctrl.currentMembership;
      let currentMembershipLevels = [
        {
          id: currentMembership?.categoryId,
          name: currentMembership?.membershipCategory,
          offerings: [
            {
              name: currentMembership?.offeringName || '',
              id: currentMembership?.offeringId || '',
            },
          ],
        },
      ];
      const currentMembershipHeader = {
        membershipLevelName: 'Current',
        $$treeLevel: 0,
      };
      let flattenedList: TODO[] = [];

      const eligibility = ctrl.eligibility === false ? undefined : ctrl.eligibility;
      const eligibleLevels = eligibility?.membershipOptions.eligibleMembershipLevels ?? [];

      if (ctrl.searchQuery) {
        currentMembershipLevels = currentMembershipLevels.filter(ctrl.searchByName);
      }

      angular.forEach(eligibleLevels, (eligibleLevel) => {
        if (eligibleLevel.targetLevels.length) {
          levels = ctrl.process(eligibleLevel.targetLevels, eligibleLevel.type);

          if (ctrl.searchQuery) {
            levels = levels.filter(ctrl.searchByName);
          }

          if (ctrl.selectedFilter) {
            switch (ctrl.selectedFilter.type) {
              case 'all':
                break;
              case 'regular':
                levels = levels.filter(ctrl.filterByRegular);
                break;
              case 'auxiliary':
                levels = levels.filter(ctrl.filterByAux);
                break;
            }
          }

          /**
           * The current membership's level information must always be at the top of the list.
           * This is done after looping through all the eligible options as renewing into the same level+offering+price point might not always be available.
           */
          if (levels.length) {
            switch (eligibleLevel.type) {
              // TODO: refactor membershipo enums to avoid using array indexes
              /**
               * We're only applying filtering for new memberships for the time being
               * to maintain prod's behavior intact
               */
              case 'new_memberships':
                flattenedList = flattenedList.concat(
                  MembershipService.flattenLevelByOfferings(levels, 'NEW_MEMBERSHIPS')
                );
                break;

              case MEMBERSHIP_ENUMS.renew[0]:
              //falls through
              case MEMBERSHIP_ENUMS.renew[3]:
              //falls through
              case MEMBERSHIP_ENUMS.renew[6]:
                currentMembershipHeader.membershipLevelName =
                  MembershipService.getMembershipTypeLabel(eligibleLevel.type) + ' (Current)';
                currentMembershipLevels = levels;
                break;
              default:
                if (ctrl.membershipId) {
                  flattenedList.push({
                    membershipLevelName: MembershipService.getMembershipTypeLabel(eligibleLevel.type),
                    $$treeLevel: 0,
                  });
                }

                flattenedList = flattenedList.concat(MembershipService.flattenLevelByOfferings(levels));
            }
          }
        }
      });

      if (ctrl.membershipId && currentMembershipLevels.length) {
        ctrl.setCurrentMembershipLevel(currentMembershipLevels);

        const isUpgradeDowngrade = ctrl.lifecycleType === 'upgradeDowngrade';

        /**
         * Current membership section should NOT be shown when doing upgrade/downgrade flow
         * @link https://acmeticketing.atlassian.net/browse/APP-753
         */
        if (!isUpgradeDowngrade) {
          flattenedList = MembershipService.flattenLevelByOfferings(currentMembershipLevels).concat(flattenedList);
          flattenedList.unshift(currentMembershipHeader);
        }
      }

      ctrl.model = flattenedList;

      ctrl.gridDefinition.isLoaded = true;
      ctrl.isLoaded = true;

      $scope.$broadcast('DataGrid::ResizeGrid', {
        name: ctrl.gridDefinition.options.gridName,
        datasetLength: ctrl.model.length,
        totalItems: ctrl.model.length,
      });

      $timeout(() => {
        if (ctrl.model.length) {
          if (ctrl.membershipId && ctrl.model.length > 1) {
            ctrl.gridDefinition.selectRows([ctrl.model[1]]);
          } else {
            ctrl.gridDefinition.selectRows([ctrl.model[0]]);
          }
        } else {
          ctrl.gridDefinition.clearSelection();
          ctrl.selected = false;
        }
      }, 10);
    },

    searchByName: (level) => {
      return level.name && level.name.toLowerCase().indexOf(ctrl.searchQuery.toLowerCase()) > -1;
    },

    filterByRegular: (level) => {
      return level.auxiliary === false;
    },

    filterByAux: (level) => {
      return level.auxiliary === true;
    },

    getLevels: () => {
      const props = ctrl.gridState.getGridState();

      props.salesChannels = 'insideSalesIndividual';
      props.isPublished = '1';
      props.summarize = '0';
      props.pageSize = '-1';
      props.membershipLevelGroup = 'individualAndFamily';

      // Note: This currentGroup var is never set, so I have no idea what it's for
      if (ctrl.currentGroup && ctrl.currentGroup.id) {
        props.collectionId = ctrl.currentGroup.id;
        if (props.excludeLevelsWithACollection) {
          delete props.excludeLevelsWithACollection;
        }
      } else {
        props.collectionId = '';
        if (ctrl.isAuxiliaryMembershipEnabled === false) {
          props.excludeLevelsWithACollection = '1'; // This excludes aux groups, no one knows why...
        }
      }

      if (props.sortField) {
        delete props.sortField;
      }

      if (props.sortDirection) {
        delete props.sortDirection;
      }
      ApiService.membership.categories.list(props).then(ctrl.success.getLevels).catch(ctrl.error.getLevels);
    },

    getMembershipEligibility: () => {
      const eligibilityTypes = ctrl.selectedLifecycle ? [ctrl.selectedLifecycle].join() : MEMBERSHIP_ENUMS.renew.join();

      ApiService.membership.eligibility
        .listByMembershipCategory({
          membershipId: ctrl.membershipId as TODO,
          // TODO: Change this to the b2b sales channel
          saleChannels: 'insideSalesIndividual',
          actions: eligibilityTypes,
          summarize: 0,
        })
        .then(ctrl.success.getMembershipEligibility)
        .catch(ctrl.error.getMembershipEligibility);
    },

    process: (model, type) => {
      angular.forEach(model, (level) => {
        //TODO: Make this purchase type text better
        if (type === MEMBERSHIP_ENUMS.renew[0]) {
          level.purchaseTypeLabel = 'Current';
        } else {
          level.purchaseTypeLabel = MembershipService.getMembershipTypeLabel(type);
        }
        level.purchaseType = MembershipService.getPurchaseType(type);
      });

      return model;
    },

    sortLevels: (list) => {
      const regular: TODO[] = [];
      const grouped = {};
      let groups: TODO[] = [];
      const aux: TODO[] = [];

      list.forEach((item) => {
        let groupName = '';
        if (!item.auxiliary) {
          regular.push(item);
        } else {
          if (!item.hasOwnProperty('membershipLevelCollection')) {
            aux.push(item);
          } else {
            groupName = item.membershipLevelCollection[0].id;
            if (grouped.hasOwnProperty(groupName)) {
              grouped[groupName].push(item);
            } else {
              grouped[groupName] = [item];
            }
          }
        }
      });

      Object.keys(grouped).forEach((item) => {
        groups = groups.concat(grouped[item]);
      });

      groups.sort((first, second) => {
        return first.membershipLevelCollection[0].displayOrder - second.membershipLevelCollection[0].displayOrder;
      });

      return [...regular, ...groups, ...aux];
    },

    processLevel: (data) => {
      const termPromises: IPromise<TODO>[] = [];

      if (data.level && data.level.offerings) {
        let auxGroupName = null;

        if (data.level.membershipLevelCollection instanceof Array && data.level.membershipLevelCollection.length > 0) {
          auxGroupName = data.level.membershipLevelCollection[0].name;
        }

        data.level.thumbnail = ctrl.getThumbnail(data.level);
        data.level.partialDescription = $sce.trustAsHtml(
          data.level.shortDescription
            ? HelpersService.strip(data.level.shortDescription, 300)
            : data.level.description
            ? HelpersService.strip(data.level.description, 300)
            : ''
        );
        data.level.longDescription = $sce.trustAsHtml(
          data.level.description
            ? data.level.description
            : data.level.shortDescription
            ? data.level.shortDescription
            : ''
        );
        data.level.auxGroupName = auxGroupName;
        angular.forEach(data.level.offerings, (offering) => {
          let canPurchase = false;
          const offeringActions = offering.actions || [];
          const hasLifeCycleActions = offeringActions.reduce((acc, action) => {
            return acc && action.ruleIds.length > 0;
          }, true);

          offeringActions.forEach((item) => {
            if (item.action === 'NEW_MEMBERSHIPS' && item.ruleIds.length > 0) {
              canPurchase = true;
            }
          });

          offering.displayDuration = HelpersService.getFormattedDuration(offering.duration);
          offering.term = MembershipService.getMembershipTerm([offering]);
          offering.hasLifeCycleActions = hasLifeCycleActions;
          offering.canPurchase = canPurchase;

          if (
            canPurchase &&
            offering.priceLists instanceof Array &&
            offering.priceLists.length &&
            offering.priceLists[0].prices instanceof Array
          ) {
            // No need to calculate if this is a renew as we have the dates
            if (offering.membershipExpirationDate === undefined) {
              // We need to load the data for each offering, so fill up a promise array and run them all
              const props = {
                action: 'MembershipPurchase',
                levelId: data.level.id,
                offeringId: offering.id,
                pricePointId: offering.priceLists[0].prices[0].personType.id,
              };

              termPromises.push(ApiService.membership.validate.detail(props));
            }

            const currentMembership = ctrl.currentMembership === false ? undefined : ctrl.currentMembership;
            if (offering.id === currentMembership?.offeringId) {
              offering.isCurrent = true;
            } else {
              data.level.hasOther = true;
            }
          }
        });
      }

      $q.all(termPromises).then((response) => {
        // $q.all guarantees the responses are in the same order as they were added
        let offeringIndex = 0;
        angular.forEach(response, (termInfo) => {
          const term = MembershipService.getMembershipTermFromStartEnd(
            termInfo.data.payload.startDate,
            termInfo.data.payload.expirationDate
          );
          data.level.offerings[offeringIndex].term = term;
          offeringIndex++;
        });
        ctrl.selected = data;
      });
    },

    getThumbnail: (level) => {
      let result = '';

      if (
        level &&
        level.images instanceof Array &&
        level.images.length &&
        level.images[0] &&
        level.images[0].thumbnail
      ) {
        result = level.images[0].thumbnail;
      } else {
        result = '/assets/img/global/no-image-landscape.png';
      }

      return result;
    },

    getScreen: (level) => {
      let result = '';

      if (level && level.images instanceof Array && level.images.length && level.images[0] && level.images[0].screen) {
        result = level.images[0].screen;
      } else {
        result = '/assets/img/global/no-image-landscape.png';
      }

      return result;
    },

    addToCart: (item) => {
      const offering = item.level.offerings[0];
      const pricepoint = MembershipService.getFirstPricepoint(offering);

      if (!offering.term) {
        ctrl.processLevel(item);
      }

      if (pricepoint && pricepoint.personType) {
        ctrl.addOfferingToCart(item.level, offering, pricepoint);
      } else {
        ctrl.error.addToCart(ctrl.createError('There are no prices available for this membership level'));
      }
    },

    createError: (message) => {
      return {
        data: {
          error: message,
        },
      };
    },

    addOfferingToCart: (level, offering, pricepoint) => {
      const membership = {
        quantity: 1,
        itemType: level.purchaseType,
        membershipId: ctrl.membershipId,
        categoryId: level.id,
        membershipCategory: level.name,
        offeringId: offering.id,
        offeringName: offering.name,
        pricePointId: pricepoint.personType.id,
        pricePointName: pricepoint.personType.name,
        amount: pricepoint.price,
        term: offering.term,
        orderContactId: ctrl.orderContactId,
        isAutorenew: ctrl.isAutorenewEnabled(offering),
      };

      // Set this here so it propagates to the cart display

      if (offering.canPurchase) {
        MembershipService.purchaseTerm = offering.term;

        if (PermissionsService.check('MEMBERSHIP_SALES')) {
          if (CartService.hasOrderContact() && !ctrl.membershipId) {
            ctrl.showMembershipMessage(membership);
          } else {
            CartService.memberships.addToCart(membership).then(ctrl.success.updateCart).catch(ctrl.error.updateCart);
          }
        }
      } else {
        $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: () => 'Membership cannot be added to cart',
            okText: () => 'Close',
            modalMessage: () => {
              return `In order to sell this membership, offering ${offering.name} needs to be configured for New Membership Sales. Configure this in Levels › Offerings › Lifecycle actions.`;
            },
          },
        });
      }
    },

    showMembershipMessage: (newMembership) => {
      const membership = CartService.getTransactingMembership();
      const orderContact = CartService.getOrderContact();
      const title = 'Proceeding will clear the cart';
      const message =
        HelpersService.getFullName(orderContact) +
        ' already has a membership: ' +
        membership.membershipCategory +
        ' (expiring ' +
        $filter('date')(membership.membershipExpirationDate, HelpersService.dateFormats.shortDate) +
        '). Adding a new membership will remove the currently transacting member and clear contents of the cart.';

      const showMessageModal: UIBModal<TODO> = $uibModal.open({
        templateUrl: 'views/application/views/membership/list/modals/member/member.tpl.html',
        size: 'md',
        controller: 'MembershipListModalsMemberController',
        resolve: {
          modalTitle: () => title,
          modalMessage: () => message,
          showRenew: () => false,
        },
      });

      showMessageModal.result
        .then((response) => {
          if (response === 'clear') {
            CartService.cancelCart()
              .then((response) => {
                ctrl.success.clearMember(response, newMembership);
              })
              .catch((response) => {
                ctrl.success.clearMember(response, newMembership);
              });
          }
        })
        .catch((response) => {
          // Close modal, do nothing
        });
    },

    viewDetail: (item) => {
      ctrl.gridDefinition.selectRows([item.entity]);
    },

    showMessage: (title, message) => {
      if (message) {
        const showMessageModal: UIBModal<TODO> = $uibModal.open({
          templateUrl: 'views/application/views/reports/create/modals/showMessage.tpl.html',
          size: 'md',
          controller: 'ReportsCreateShowMessageModalController',
          resolve: {
            currentTitle: () => title,
            currentMessage: () => message,
            safe: () => true,
          },
        });
        // Invoked when modal completes with close(params)
        showMessageModal.result
          .then(() => {})
          .catch(() => {
            // Do nothing
          });
      }
    },

    getPurchaseTypeLabel: (type) => {
      return MembershipService.getMembershipTypeLabel(type);
    },

    hasPricepointMatch: () => {
      let result = false;

      if (ctrl.currentMembership && ctrl.selected && ctrl.selected.level) {
        result = CartService.memberships.hasPricepointMatchForLevel(ctrl.currentMembership, ctrl.selected.level);
      }

      return result;
    },

    hasOfferingMatch: () => {
      let result = false;

      if (ctrl.currentMembership && ctrl.selected && ctrl.selected.level) {
        result = CartService.memberships.hasOfferingMatchForLevel(ctrl.currentMembership, ctrl.selected.level);
      }

      return result;
    },

    isAutorenewOffering: ({ autorenewalType }: Pick<MembershipLevelOffering, 'autorenewalType'>) => {
      return CartService.memberships.isAutorenewType({ autorenewalType });
    },

    isAutorenewEnabled: ({ autorenewalType }: Pick<MembershipLevelOffering, 'autorenewalType'>) => {
      return ctrl.isAutorenewOffering({ autorenewalType }) && autorenewalType === 'required';
    },

    setCurrentMembershipLevel: (levels) => {
      let found = false;

      const currentMembership = ctrl.currentMembership === false ? undefined : ctrl.currentMembership;

      if (!currentMembership) {
        return;
      }

      angular.forEach(levels, (level) => {
        if (level.id === currentMembership.categoryId) {
          angular.forEach(level.offerings, (offering) => {
            if (offering.id === currentMembership?.offeringId) {
              found = true;
              currentMembership.offering = offering;
              if (offering.priceLists instanceof Array && offering.priceLists.length) {
                angular.forEach(offering.priceLists[0].prices, (price) => {
                  if (price.personType.id === currentMembership?.pricePointId) {
                    currentMembership.pricepoint = price;
                  }
                });
              }
            }
          });
        }
      });

      if (!found && ctrl.currentMembership) {
        ctrl.currentMembership.offering = {
          name: ctrl.currentMembership.offeringName || '',
          id: ctrl.currentMembership.offeringId || '',
        };
      }
    },

    success: {
      init: (response) => {},
      getLevels: (response) => {
        const levels = ctrl.sortLevels(ctrl.process(response.data.payload.list, 'new_memberships'));

        ctrl.eligibility = {
          membershipOptions: {
            eligibleMembershipLevels: [
              {
                type: 'new_memberships',
                targetLevels: levels,
              },
            ],
          },
        };
        ctrl.search();
      },

      getMembershipEligibility: (response) => {
        ctrl.eligibility = response.data.payload;

        ctrl.search();
      },
      updateCart: (response) => {
        $scope.$emit('Cart::Open');
      },

      getMembership: (response) => {
        ctrl.currentMembership = response.data.payload;
        ctrl.getMembershipLevels();
      },
      clearMember: (response, membership) => {
        CartService.memberships.addToCart(membership).then(ctrl.success.updateCart).catch(ctrl.error.updateCart);
      },
    },

    error: {
      init: (response) => {},
      getLevels: (response) => {
        ctrl.showMessage('An error occurred', 'Unable to retrieve membership levels.');
      },
      getMembershipEligibility: (response) => {
        ctrl.showMessage('An error occurred', 'Unable to retrieve eligible sales actions for this membership.');
      },
      updateCart: (response) => {
        const errorMsg = HelpersService.path(response, ['data', 'error'], 'Unable to update cart');
        ctrl.showMessage('An error occurred', errorMsg);
      },
      addToCart: (response) => {
        const error = response.data.error;
        ctrl.showMessage('An error occurred', error);
      },
      getMembership: (response) => {
        ctrl.showMessage('An error occurred', 'Unable to retrieve this membership.');
      },
      clearMember: (response) => {
        ctrl.showMessage('An error occurred', 'Unable to clear the cart');
      },
    },

    onDataGridPaginate: (newPageNumber: number, newPageSize: number, sortField?: string, sortDirection?: string) => {
      const data = {
        currentPage: newPageNumber || 1,
        pageSize: newPageSize || ctrl.gridDefinition.options.paginationPageSize,
      };

      ctrl.gridState.updateGridState(data.currentPage, data.pageSize);
      if (sortField) {
        ctrl.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        ctrl.gridState.updateGridState(null, null, null, sortDirection);
      }

      ctrl.getLevels();
    },

    onDataGridSortChange: (grid, columns) => {
      const data = columns[0];

      if (data) {
        ctrl.gridState.updateGridState(null, null, data.field, data.sort.direction);

        ctrl.getLevels();
      }
    },

    onDataGridSelectionChange: (row, e) => {
      if (row.isSelected) {
        ctrl.processLevel(row.entity);
        ctrl.showFullDetails = false;
      }
    },
  };

  $scope.retailMemberships = ctrl;
  ctrl.init();
}

export const RetailMembershipsControllerModule = angular
  .module('acme.view.application.retail.memberships.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    'acme.common.service.featureToggle',
    'acme.common.service.userPreferences',
    'acme.common.service.themesHelper',
    'acme.common.service.membership',
    CartServiceModule,
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.view.application.reports.create.showMessageModal.controllers',
    'acme.view.application.modals.confirm.controllers',
    'acme.view.application.modals.membership.controllers',
    'acme.view.application.membership.list.modals.member.controllers',
    AutorenewRetailPriceComponentModule,
  ])
  .controller('RetailMembershipsController', RetailMembershipsController).name;
